type RootAppShellState = {
  isAppLoading: boolean;
  appNotice: {
    open: boolean;
    title?: string;
    message: string;
    status: number | null;
    details: string;
    messageFormatted: string;
    action: string;
    endpointName: string;
    errors?: Record<string, string[]>;
    validationErrors?: Record<string, string[]>; // compat
    redirectTo?: string | null;
    variant?: 'warning' | 'danger' | 'info' | 'success' | 'permission';
  };
  idleTimer: {
    showModal: boolean;
    action: string;
  };
  language: string;
};

export const initialAppShellState: RootAppShellState = {
  isAppLoading: false,
  appNotice: {
    open: false,
    message: '',
    status: null,
    details: '',
    messageFormatted: '',
    action: '',
    endpointName: '',
    errors: {},
    validationErrors: {},
    redirectTo: null,
    variant: 'warning',
  },
  idleTimer: {
    showModal: false,
    action: '',
  },
  language: 'es',
};
